export default "__VITE_ASSET__BYbeV9QW__"